<div class="card">
  <div class="card-header">
    <h4>CMA Report</h4>
  </div>
  <div class="card-body m-0">
    <!-- Quick Filter Section -->
    <div class="row" style="min-height: 100px">

      <div class="row" style="min-height: 100px">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="cmaForm">
              <div class="row">
                <div class="col-md-4">
                  <label class="col-form-label" for="fromDateTime">From Date & Time<span aria-hidden="true"
                      class="symbol required" style="color:red;">*</span></label>
                  <!-- <input type="datetime-local" formControlName="fromDate" class="form-control" id="fromDate" placeholder="Select From Date"
    [max]="currentDate" (change)="changeFromDate($event)" /> -->
                  <input id="startDateTime" type="datetime-local" class="form-control" formControlName="fromDate"
                    [(ngModel)]="startDateTime" (change)="onStartDateTimeChange()" name="startDateTime" required
                    [max]="currentDateTime" />
                  <div class="invalid-feedback" style="display: block;"
                    *ngIf="submitted && cmaFormControls.fromDate.errors">
                    <div *ngIf="cmaFormControls.fromDate.errors?.required">
                      From Date & Time is required
                    </div>
                  </div>
                </div>

                <!-- To DateTime Picker -->
                <div class="col-md-4">
                  <label class="col-form-label" for="toDateTime">To Date & Time<span aria-hidden="true"
                      class="symbol required" style="color:red;">*</span></label>
                  <!-- <input type="datetime-local" formControlName="toDate" class="form-control" id="toDate" placeholder="Select To Date"
    [max]="toCurrentDate" [min]="fromCurrentDate" (change)="changeToDate($event)" /> -->
                  <input id="endDateTime" type="datetime-local" class="form-control" [(ngModel)]="endDateTime"
                    (change)="onEndDateTimeChange()" name="endDateTime" formControlName="toDate" [min]="startDateTime"
                    [max]="currentDateTime" />

                  <!-- Validation Feedback -->
                  <!-- <div class="invalid-feedback" style="display: block;"
                    *ngIf="submitted && cmaForm.errors?.dateRangeInvalid">
                    To Date must be later than From Date.
                  </div> -->

                  <div class="invalid-feedback" style="display: block;"
                    *ngIf="submitted && cmaFormControls.toDate.errors?.required">
                    To Date & Time is required
                  </div>
                </div>






                <!-- Account Number Field -->
                <div class="col-md-4">
                  <label class="col-form-label" for="accountNumber">Account Number<span aria-hidden="true"
                      class="symbol required" style="color:red;">*</span></label>
                  <ng-select id="accountNumber" formControlName="accountNumber" placeholder="Select Account Number"
                    name="accountNumber" placeholder="Enter Account Number">
                    <ng-option *ngFor="let account of accountData"
                      value="{{account.accountNumber}}">{{account.accountName}}({{account.accountNumber}})</ng-option>
                  </ng-select>
                  <div class="invalid-feedback" style="display: block;"
                    *ngIf="submitted && cmaFormControls.accountNumber.errors">
                    <div *ngIf="cmaFormControls.accountNumber.errors?.required">
                      Account Number is required
                    </div>
                  </div>
                </div>
              </div>

              <!-- Submit Button -->
              <div class="row mt-2 justify-content-end text-right">
                <div class="mb-3 col-md-2">
                  <button class="btn bg-danger-custom" type="button" (click)="searchStatement()">
                    <i class="feather icon-search"></i> Submit
                  </button>
                  <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


    </div>

    <!-- Statement Details Grid -->
    <div class="row mb-2 mt-4">
      <div class="col-xl-3">
        <h5 class="mb-3"> Statement Details:</h5>
      </div>
      <div class="col-xl-9 text-end">
        <!--<button type="button" class="btn btn-primary " (click)="onBtnC($event)">Add Rows</button>-->

        <button type="button" class="btn bg-danger-custom btn-sm" *ngIf="permissions.includes('Search')" (click)="onExportCSV()">
          Export Excel<i class="feather icon-download"></i></button>

          <button type="button" class="btn bg-danger-custom btn-sm" *ngIf="permissions.includes('Search')" (click)="onBackgroundExport()">
            Export All<i class="feather icon-download"></i></button>

      </div>
    </div>
    <div class="row mb-0" style="min-height: 350px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
        <ag-grid-angular [enableCellTextSelection]="true" (gridReady)="onGridReady($event)"
          [columnDefs]="statementColumnDefs" [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [rowData]="rowData"
          [domLayout]="'autoHeight'" [rowSelection]="'single'" style="width: 100%; height: auto;"
          [gridOptions]="gridOptions">
        </ag-grid-angular>
      </div>
    </div>

    <!-- Pagination for Statement Details -->
    <div class="row mb-2" *ngIf="rowData.length">
      <div class="col-4 col-xs-4 d-flex">
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanges($event)"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ statementCollectionSize }}</p>
      </div>
      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="pageNumber" [boundaryLinks]="true"
          [collectionSize]="statementCollectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
          class="d-flex justify-content-end col-8 align-right" [ellipses]="false">
        </ngb-pagination>
      </div>
    </div>
    <hr>
    <!-- Request Details Grid -->
    <h5 class="mb-4 mt-2"> Request Details</h5>
    <div class="row mb-0" style="min-height: 380px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 10px">
        <ag-grid-angular [enableCellTextSelection]="true" (gridReady)="onGridReadyRequest($event)"
          [columnDefs]="requestColumnDefs" [defaultColDef]="defaultColDef1" [tooltipShowDelay]="0"
          [rowData]="requestRowData" [rowSelection]="'single'" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>
    <!-- Pagination for Request Details -->
    <div class="row" *ngIf="requestRowData.length">
      <div class="col-4 col-xs-4 d-flex">
        <select [(ngModel)]="pageRecords" (ngModelChange)="onPageSizeChangesRequest($event)"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ requestCollectionSize }}</p>
      </div>
      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChangeRequest($event)" [(page)]="requestPageNumber" [ellipses]="false"
          [boundaryLinks]="true" [collectionSize]="requestCollectionSize" [maxSize]="5" [pageSize]="pageRecords"
          [rotate]="false" class="d-flex justify-content-end col-8 align-right" [directionLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>